export const PASSWORD_REQUIREMENTS = [
  {
    message: 'Must be at least 8 characters long',
    isValid: (password: string) => password?.length >= 8,
  },
  {
    message: 'Must contain a number',
    isValid: (password: string) => /[0-9]/.test(password),
  },
  {
    message: 'Must contain a lowercase letter',
    isValid: (password: string) => password?.length > 0 && /[a-z]/.test(password),
  },
  {
    message: 'Must contain an uppercase letter',
    isValid: (password: string) => /[A-Z]/.test(password),
  },
  {
    message: 'Must contain a special character',
    isValid: (password: string) => /[^\w\s]|_/g.test(password),
  },
];
